import * as React from 'react';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { startCase } from 'lodash';

const ToggleButtonComponent = (props) => {
  const { data, active, setActive, isEdit, current } = props;

  const handleChange = (event, newAlignment) => {
    setActive(newAlignment);
  };

  return (
    <ToggleButtonGroup
      color="primary"
      value={active}
      exclusive
      onChange={handleChange}
      aria-label="Platform"
      disabled={(current === "QC" && !isEdit)}
    >
        {
            data?.map((item, index) => {
               return <ToggleButton  sx={{
                '&.Mui-selected': {
                    backgroundColor: (current === "QC" && !isEdit) ? "#6b7280" : '#f16253',
                    color: 'white',
                },
                '&.Mui-selected:hover': {
                    backgroundColor: '#f16253',
                },
                width: 'auto', // Divide width equally if width prop is provided
            }} key={index} value={item}>
              {startCase(item)}
            </ToggleButton>
            })
        }
    </ToggleButtonGroup>
  );
}

export default ToggleButtonComponent;
